import angular from 'angular';
import billingModule from '../../billing.module';

class guestAccessService {
    constructor(
        $q,
        $sessionStorage,
        billingConfigurationApiService,
        billingGuestTokenApiService,
        sessionStorageConstants,
        sessionTypeConstants
    ) {
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.billingConfigurationApiService = billingConfigurationApiService;
        this.billingGuestTokenApiService = billingGuestTokenApiService;
        this.sessionStorageConstants = sessionStorageConstants;
        this.sessionTypeConstants = sessionTypeConstants;
    }

    getLoginForm(formData) {
        var deferred = this.$q.defer();

        this.billingConfigurationApiService
            .getGuestAccessConfiguration()
            .then(data => {
                var asuiDynamicFormObject = {
                    items: []
                };

                for (var fieldIndex in data.fields) {
                    var field = data.fields[fieldIndex];
                    var item = {
                        label: field.label,
                        name: field.name,
                        validation: {
                            required: {
                                value: true,
                                message: `${field.label} is required`
                            }
                        },
                        type: 'textbox',
                        model: formData[field.name]
                    };
                    asuiDynamicFormObject.items.push(item);
                }

                deferred.resolve(asuiDynamicFormObject);
            }, deferred.reject);

        return deferred.promise;
    }

    login(asuiItems) {
        var requestBody = {};

        for (var i in asuiItems) {
            var item = asuiItems[i];
            requestBody[item.name] = item.model;
        }

        var deferred = this.$q.defer();

        this.billingGuestTokenApiService
            .getGuestToken(requestBody)
            .then(data => {
                angular.merge(data, {
                    expiresOn:
                        new Date().getTime() +
                        Math.max((data.expires - 300) * 1000, 0)
                });

                this.$sessionStorage[
                    this.sessionStorageConstants.tokenBilling
                ] = data;
                this.$sessionStorage[
                    this.sessionStorageConstants.sessionType
                ] = this.sessionTypeConstants.guest;

                deferred.resolve(data);
            }, deferred.reject);

        return deferred.promise;
    }
}

export default billingModule.service('guestAccessService', guestAccessService);



// WEBPACK FOOTER //
// ./modules/billing/services/guestAccess/guestAccess.service.js